var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 0.400391L6.99922 7.33339L1.79922 0.400391L0.199219 1.60039L4.99922 8.00039H1.99922V10.0004H5.99922V12.0004H1.99922V14.0004H5.99922V18.0004H7.99922V14.0004H11.9992V12.0004H7.99922V10.0004H11.9992V8.00039H8.99922L13.7992 1.60039L12.1992 0.400391Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward_icon.600d7e60dde647bc6f3ff6db7a23a54f.svg";
export { ForwardRef as ReactComponent };